export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';
